export const rentalDocuments = {
  intro:
    "Conoce los documentos que normalmente se solicitan para rentar. La lista puede cambiar segun el local, el propietario o el tipo de contrato.",
  personaFisica: [
    "Identificacion oficial vigente.",
    "Comprobante de domicilio reciente.",
    "RFC o constancia de situacion fiscal.",
    "Comprobante de ingresos o actividad comercial.",
    "Fiador solidario u obligado solidario, si aplica.",
  ],
  personaMoral: [
    "Acta constitutiva.",
    "Poder del representante legal.",
    "Identificacion oficial del representante legal.",
    "RFC o constancia de situacion fiscal de la empresa.",
    "Comprobante de domicilio fiscal.",
  ],
};
